import { LifecycleStage } from '@vendasta/account-group';
import { SelectInputOptionInterface } from '@vendasta/galaxy/input';

export function allStageOptions(): SelectInputOptionInterface[] {
  return <SelectInputOptionInterface[]>[
    {
      label: 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.LEAD',
      value: LifecycleStage.LIFECYCLE_STAGE_LEAD,
    },
    {
      label: 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.PROSPECT',
      value: LifecycleStage.LIFECYCLE_STAGE_PROSPECT,
    },
    {
      label: 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.CUSTOMER',
      value: LifecycleStage.LIFECYCLE_STAGE_CUSTOMER,
    },
  ];
}
